var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('external-account-from',{on:{"save":_vm.addAccount}})}
var staticRenderFns = []

export { render, staticRenderFns }